function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { Fragment } from 'react';
import { renderToString } from 'react-dom/server';
import { FetchWrapper } from './fetch-wrapper';
import Loader from './loader';
var defaultSettings = {
  "ClientId": "0a1df890-bfdb-44ac-b3f0-96aab07afff1",
  "TenantName": "dgsidtest",
  "TenantDomain": "onmicrosoft.com",
  "RedirectUrl": "https://hcpportal.local.cas.dgs.com/~/oneIdlogin",
  "LoginUrl": "/~/oneIdlogin",
  "ApiBaseUrl": "https://dev.api.dgs.com/OneCustomer-Dev/v1",
  "CultureCode": "en",
  "CountryCode": "DK",
  "UserListSize": 30,
  "UseDataLocation": false //TODO REMOVE AFTER DATA LOCATION IS LIVE
};
var defaultUserStatus = {
  "StatusCompleted": "Completed",
  "StatusPending": "Pending",
  "StatusInvitationExpired": "Invitation Expired",
  "StatusInvitationFailed": "Invitation failed"
};
var defaultToolTip = {
  "EditUser": "Edit user",
  "RemoveUser": "Remove user",
  "SendInvite": "Send invitation"
};
function setUserStatusIcon(status) {
  return status.toLowerCase() == "completed" ? "icon-completed" : "icon-pending";
}
function setUserStatusBtn(status) {
  return status.toLowerCase() == "completed";
}
function setUserStatusClassName(status) {
  return "user-status-".concat(status.toLowerCase() == "completed" ? "completed" : "pending");
}
function titlesColumns(componentParentElem) {
  var $thItems = componentParentElem.querySelectorAll('.remotecare-admin-panel-userlist-table table thead tr th');
  $thItems = Array.from($thItems);
  var thItemsTexts = [];
  var _iterator = _createForOfIteratorHelper($thItems),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var $thItem = _step.value;
      var textThItem = $thItem.textContent.trim();
      thItemsTexts.push(textThItem);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return thItemsTexts;
}
function clearInputs(moduleElement) {
  var inputs = moduleElement.querySelectorAll('.remotecare-admin-panel-popup input');
  inputs.forEach(function (inpt) {
    inpt.value = '';
  });
}
function validateInput(input, type) {
  var emailRegEx = /^([;,]?\s?([a-zA-Z0-9_\-\.\+]+)@([a-zA-Z0-9_\-\.\+]+)\.([a-zA-Z]{2,5}){1,25})+$/;
  var textRegEx = new RegExp('^[a-zA-Z]{1}');
  var inptParent = input.parentElement;
  var isOk = false;
  switch (type) {
    case 'email':
      isOk = emailRegEx.test(input.value);
      break;
    case 'country':
      isOk = input.value !== "-1";
      break;
    default:
      isOk = textRegEx.test(input.value);
      break;
  }
  if (!isOk) {
    inptParent.classList.add('error');
  } else {
    inptParent.classList.remove('error');
  }
  return isOk;
}
function showMsg(data) {
  return /*#__PURE__*/React.createElement("p", {
    className: "remotecare-admin-panel-msg"
  }, data);
}
function disabledStateSearchBox($input, $btn, state) {
  $input.disabled = state;
  $btn.disabled = state;

  // Set focus on input after search
  if (!state) {
    $input.focus();
  }
}
function loaderRenderToString() {
  return renderToString(/*#__PURE__*/React.createElement(Loader, null));
}
function showLoaderInBtn($button, showLoader) {
  var btnText = $button.textContent;
  if (showLoader) {
    $button.style.paddingRight = '5rem';
    $button.innerHTML = "".concat(btnText).concat(loaderRenderToString());
  } else {
    $button.removeAttribute('style');
    $button.querySelector('.remotecare-admin-panel-loader').remove();
  }
}
var UsersList = /*#__PURE__*/function (_React$Component) {
  function UsersList(props) {
    var _this;
    _classCallCheck(this, UsersList);
    _this = _callSuper(this, UsersList, [props]);
    _this.state = {
      showModal: false,
      modalId: '',
      users: [],
      countries: [],
      tableColumnTitles: [],
      loading: true,
      loadMore: false,
      loadOnSearch: false
    };
    _this.searchParams = {
      page: 1,
      size: 30,
      search: ''
    };
    _this.moduleElement = document.querySelector('.remotecare-admin-panel');
    _this.$inputSearch = _this.moduleElement.querySelector('#remotecare-admin-panel-search-110101');
    _this.$btnSearch = _this.moduleElement.querySelector('#remotecare-admin-panel-search-110101 + button');
    _this.msg = {
      notFound: _this.moduleElement.dataset.msgNotfound
    };
    _this.actEmployee = null;
    _this.usersCount = 0;
    _this.settings = _this.getSettingsFromComponent(_this.moduleElement);
    _this.userStatusLabels = _this.getUserStatusLabelsFromComponent(_this.moduleElement);
    _this.tooltiplabels = _this.getToolTipsLabelsFromComponent(_this.moduleElement);
    _this.dropdownResetPasswordButton = document.querySelector('.remotecare-user-panel li[data-currentuser-email] a');
    if (_this.settings.UseDataLocation)
      //TODO REMOVE AFTER DATA LOCATION IS LIVE
      {
        _this.$selectCountryList = $('#popup-edit-country', _this.moduleElement);
      }
    _this.$editFirstName = $('#popup-edit-firstname', _this.moduleElement);
    _this.$editLastName = $('#popup-edit-lastname', _this.moduleElement);
    return _this;
  }
  _inherits(UsersList, _React$Component);
  return _createClass(UsersList, [{
    key: "init",
    value: function init() {
      this.settings.debug = false;
      if (this.settings.debug) console.log(this.settings);
      if (this.settings.UserListSize) this.searchParams.size = this.settings.UserListSize;
      FetchWrapper.init(this.settings);
      this.setPopups();
      this.setResetPasswordButton();
      this.getData();
    }
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[data-hcpid="panel-settings"]');
      var settings = defaultSettings;
      try {
        settings = JSON.parse(settingsElement.textContent);
        var userEmailLi = document.querySelector('.remotecare-user-panel li[data-currentuser-email]');
        settings.CurrentUserEmail = userEmailLi ? userEmailLi.getAttribute('data-currentuser-email') : '';
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      return settings;
    }
  }, {
    key: "getUserStatusLabelsFromComponent",
    value: function getUserStatusLabelsFromComponent(component) {
      var statusElement = component.querySelector('script[data-hcpid="user-status-labels"]');
      var datalist = defaultUserStatus;
      try {
        datalist = JSON.parse(statusElement.textContent);
      } catch (e) {
        datalist.error = "".concat(e.name, " - ").concat(e.message);
      }
      return datalist;
    }
  }, {
    key: "getToolTipsLabelsFromComponent",
    value: function getToolTipsLabelsFromComponent(component) {
      var tooltipElement = component.querySelector('script[data-hcpid="tool-tip-labels"]');
      var datalist = defaultToolTip;
      try {
        datalist = JSON.parse(tooltipElement.textContent);
      } catch (e) {
        datalist.error = "".concat(e.name, " - ").concat(e.message);
      }
      return datalist;
    }
  }, {
    key: "setResetPasswordButton",
    value: function setResetPasswordButton() {
      var _this2 = this;
      this.dropdownResetPasswordButton.addEventListener("click", function (e) {
        e.preventDefault();
        _this2.showPopup('popup-user-password-reset');
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this3 = this;
      FetchWrapper.fetchData().then(function (data) {
        _this3.setState({
          users: data.items,
          tableColumnTitles: titlesColumns(_this3.moduleElement),
          loading: false
        });
        _this3.setSearchBox();
        _this3.setLoadMore();
        _this3.checkLoadMore(data.total);
      }).catch(function (error) {
        return _this3.getError(error);
      });
      //TODO REMOVE AFTER DATA LOCATION IS LIVE
      if (this.settings.UseDataLocation) {
        FetchWrapper.fetchCountries(this.settings.CountryCode).then(function (data) {
          if (_this3.settings.debug) console.log("get countries", _this3.settings.CountryCode);
          _this3.setState({
            countries: data
          });
          _this3.setCountries();
        }).catch(function (error) {
          return _this3.getError(error);
        });
      }
    }
  }, {
    key: "loadEmployees",
    value: function () {
      var _loadEmployees = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setState({
                loading: true
              });
              _context.prev = 1;
              _context.next = 4;
              return FetchWrapper.fetchEmployees(this.searchParams);
            case 4:
              data = _context.sent;
              if (this.state.loadOnSearch) {
                disabledStateSearchBox(this.$inputSearch, this.$btnSearch, false);
              }
              this.setState({
                users: data.items,
                loading: false,
                loadOnSearch: false
              });
              this.checkLoadMore(data.total);
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", this.getError(_context.t0));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 10]]);
      }));
      function loadEmployees() {
        return _loadEmployees.apply(this, arguments);
      }
      return loadEmployees;
    }()
  }, {
    key: "getError",
    value: function getError(error) {
      if (this.settings.debug) console.log("error", error);
      switch (error) {
        case 'Auth_error':
          this.showPopup('popup-user-session-expired');
          break;
        case 'Server_error':
        default:
          this.showPopup('popup-server-problems');
          break;
      }
      return error;
    }
  }, {
    key: "setCountries",
    value: function setCountries() {
      var _this4 = this;
      if (this.settings.debug) console.log("add countries");
      this.$selectCountryList.find('option:not(:first)').remove();
      this.$selectCountryList.parent().addClass('select-container');
      $.each(this.state.countries, function (index, value) {
        _this4.$selectCountryList.append('<option value=' + value.code + '>' + value.name + '</option>');
      });
    }
  }, {
    key: "setCountrySelected",
    value: function setCountrySelected(countrycode) {
      if (this.settings.debug) console.log("set selected");
      if (countrycode != null && countrycode.length > 0) {
        this.$selectCountryList.val(countrycode);
      } else {
        this.$selectCountryList.val(this.settings.CountryCode);
      }
    }
  }, {
    key: "showMsgPopup",
    value: function showMsgPopup(message, $btnAccept) {
      showLoaderInBtn($btnAccept, false);
      this.showPopup('popup-messages');
      var $popupMessage = this.moduleElement.querySelector('.popup-messages');
      $popupMessage.querySelector('.popup-subtitle').innerHTML = message;
    }
  }, {
    key: "setPopups",
    value: function setPopups() {
      var _this5 = this;
      //get all popups 
      var popups = this.moduleElement.querySelectorAll('.remotecare-admin-panel-popup');
      popups.forEach(function (element) {
        var btnCancel = element.querySelector('.button-cancel');
        var btnAccept = element.querySelector('.button-accept');
        if (element.classList.contains('popup-user-edit')) {
          var dataMsgSuccess = _this5.moduleElement.querySelector('.popup-user-edit').dataset.msgSuccessEdit;
          var fname = _this5.$editFirstName[0];
          var lname = _this5.$editLastName[0];
          var countrycode = null;
          if (_this5.settings.UseDataLocation)
            //TODO REMOVE AFTER DATA LOCATION IS LIVE
            {
              countrycode = _this5.$selectCountryList[0];
            }
          btnAccept.addEventListener('click', function (e) {
            e.target.disabled = true;
            var validateResult = false;
            if (_this5.settings.UseDataLocation)
              //TODO REMOVE AFTER DATA LOCATION IS LIVE
              {
                validateResult = validateInput(fname) && validateInput(lname) && validateInput(countrycode);
              } else {
              validateResult = validateInput(fname) && validateInput(lname);
            }
            if (validateResult) {
              var countryCodeValue = countrycode != null ? countrycode.value : null;
              showLoaderInBtn(e.target, true);
              FetchWrapper.editEmployee(_this5.actEmployee.personId, fname.value, lname.value, countryCodeValue).then(function () {
                _this5.loadEmployees().then(function () {
                  e.target.disabled = false;
                  _this5.hidePopup();
                  _this5.showMsgPopup(dataMsgSuccess, e.target);
                });
              }).catch(function (error) {
                e.target.disabled = false;
                showLoaderInBtn(e.target, false);
                _this5.hidePopup();
                _this5.getError(error);
              });
            } else {
              e.target.disabled = false;
            }
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-password-reset')) {
          var _dataMsgSuccess = _this5.moduleElement.querySelector('.popup-user-password-reset').dataset.msgSuccessReset;
          btnAccept.addEventListener('click', function (e) {
            showLoaderInBtn(e.target, true);
            e.target.disabled = true;
            FetchWrapper.resetPassword(_this5.settings.CurrentUserEmail, true).then(function () {
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.showMsgPopup(_dataMsgSuccess, e.target);
            }).catch(function (error) {
              showLoaderInBtn(e.target, false);
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.getError(error);
            });
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-invitation')) {
          var _dataMsgSuccess2 = _this5.moduleElement.querySelector('.popup-user-invitation').dataset.msgSuccessInvitation;
          btnAccept.addEventListener('click', function (e) {
            e.target.disabled = true;
            var email = document.getElementById('popup-invitation-email');
            var msgTxtDefault = document.getElementById('popup-invitation-defaulttext');
            var msgTxtPersonal = document.getElementById('popup-invitation-personaltext');
            if (validateInput(email, 'email')) {
              showLoaderInBtn(e.target, true);
              var separators = [';', ','];
              var emailArr = email.value.split(new RegExp(separators.join('|'), 'g'));
              var emails = emailArr.map(function (email) {
                return email.trim();
              });
              FetchWrapper.sendInv(emails, msgTxtDefault.innerHTML, msgTxtPersonal.innerHTML).then(function () {
                _this5.loadEmployees().then(function () {
                  e.target.disabled = false;
                  _this5.hidePopup();
                  _this5.showMsgPopup(_dataMsgSuccess2, e.target);
                });
              }).catch(function (error) {
                showLoaderInBtn(e.target, false);
                e.target.disabled = false;
                _this5.hidePopup();
                _this5.getError(error);
              });
            } else {
              e.target.disabled = false;
            }
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-remove')) {
          var _dataMsgSuccess3 = _this5.moduleElement.querySelector('.popup-user-remove').dataset.msgSuccessRemove;
          btnAccept.addEventListener('click', function (e) {
            showLoaderInBtn(e.target, true);
            e.target.disabled = true;
            _this5.searchParams.page = 1;
            FetchWrapper.removeEmployee(_this5.actEmployee.id, _this5.actEmployee.invitationId).then(function () {
              _this5.loadEmployees().then(function () {
                e.target.disabled = false;
                _this5.hidePopup();
                _this5.showMsgPopup(_dataMsgSuccess3, e.target);
              });
            }).catch(function (error) {
              showLoaderInBtn(e.target, false);
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.getError(error);
            });
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-server-problems')) {
          btnAccept.addEventListener('click', function () {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-session-expired')) {
          btnAccept.addEventListener('click', function () {
            window.location.href = _this5.settings.LoginUrl;
          });
        }
        if (element.classList.contains('popup-messages')) {
          btnAccept.addEventListener('click', function () {
            _this5.hidePopup();
          });
        }
      });

      // add new user popup
      var addNewUser = this.moduleElement.querySelectorAll('.remotecare-admin-panel-add-user');
      addNewUser.forEach(function (btn) {
        btn.addEventListener('click', function () {
          _this5.showPopup('popup-user-invitation');
        });
      });
    }
  }, {
    key: "setSearchBox",
    value: function setSearchBox() {
      var _this6 = this;
      if (this.settings.debug) console.log('search setup');
      this.$btnSearch.addEventListener('click', function () {
        submitInput();
      });
      this.$inputSearch.addEventListener('keypress', function (e) {
        if (e.keyCode == 13) {
          submitInput();
        }
      });
      var submitInput = function submitInput() {
        var inputVal = _this6.$inputSearch.value;
        _this6.setState({
          loadOnSearch: true
        });
        disabledStateSearchBox(_this6.$inputSearch, _this6.$btnSearch, true);
        _this6.checkLoadMore(0);
        _this6.searchParams.page = 1;
        _this6.searchParams.search = inputVal;
        _this6.loadEmployees();
      };
    }
  }, {
    key: "setLoadMore",
    value: function setLoadMore() {
      var _this7 = this;
      this.moreBtn = this.moduleElement.querySelector('.remotecare-admin-panel-more-btn');
      this.moreBtn.addEventListener('click', function (e) {
        _this7.searchParams.page++;
        _this7.moreBtn.disabled = true;
        _this7.setState({
          loading: true,
          loadMore: true
        });
        FetchWrapper.fetchEmployees(_this7.searchParams).then(function (data) {
          var newData = [].concat(_toConsumableArray(_this7.state.users), _toConsumableArray(data.items));
          _this7.setState({
            users: newData,
            loading: false,
            loadMore: false
          });
          _this7.moreBtn.disabled = false;
          _this7.checkLoadMore(data.total);
        }).catch(function (error) {
          _this7.getError(error);
          _this7.moreBtn.disabled = false;
        });
      });
    }
  }, {
    key: "checkLoadMore",
    value: function checkLoadMore(total) {
      if (this.state.users.length < total) {
        this.moreBtn.style.display = 'inline-block';
      } else {
        this.moreBtn.style.display = 'none';
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "loadPopup",
    value: function loadPopup(event) {
      var trg = $(event.target);
      var popupId = trg.closest('[data-popup-id]').attr('data-popup-id');
      var rowIndex = trg.closest('[data-user-index]').attr('data-user-index');
      this.actEmployee = this.state.users[rowIndex];
      this.showPopup(popupId);
    }
  }, {
    key: "showPopup",
    value: function showPopup(popupId) {
      var actPopup;
      actPopup = this.moduleElement.querySelector('.remotecare-admin-panel-popup.show-me');
      if (actPopup) actPopup.classList.remove('show-me');
      actPopup = this.moduleElement.querySelector('.' + popupId);
      actPopup.classList.add('show-me');
      var userName = actPopup.querySelector('[data-user-name]');
      if (userName) {
        var fnameTxt = this.actEmployee.firstName ? this.actEmployee.firstName : '';
        var lnameTxt = this.actEmployee.lastName ? this.actEmployee.lastName : '';
        actPopup.querySelector('[data-user-name]').innerHTML = fnameTxt + " " + lnameTxt;
        if (this.settings.debug) console.log("set data for edit");
        // set data to inputs
        this.$editFirstName.val(this.actEmployee.firstName);
        this.$editLastName.val(this.actEmployee.lastName);
        //TODO REMOVE AFTER DATA LOCATION IS LIVE       
        if (this.settings.UseDataLocation) {
          this.setCountrySelected(this.actEmployee.countryCode);
        }
      }
      var email = document.getElementById('popup-invitation-email');
      if (email && this.actEmployee) {
        email.value = this.actEmployee.email;
      }
    }
  }, {
    key: "hidePopup",
    value: function hidePopup() {
      this.moduleElement.querySelector('.remotecare-admin-panel-popup.show-me').classList.remove('show-me');
      this.actEmployee = null;
      clearInputs(this.moduleElement);
      var errorInpts = this.moduleElement.querySelectorAll('.input-container.error');
      errorInpts.forEach(function (inpt) {
        inpt.classList.remove('error');
      });
    }
  }, {
    key: "setUserStatusLabel",
    value: function setUserStatusLabel(status) {
      switch (status) {
        case 'Completed':
          return this.userStatusLabels.StatusCompleted;
        case 'Pending':
          return this.userStatusLabels.StatusPending;
        case 'InvitationExpired':
          return this.userStatusLabels.StatusInvitationExpired;
        case 'InvitationFailed':
          return this.userStatusLabels.StatusInvitationFailed;
        default:
          return '';
      }
    }
  }, {
    key: "RendererUsers",
    value: function RendererUsers() {
      var _this8 = this;
      var cellActionsStyles = {
        width: "auto",
        minWidth: "120px"
      };
      var users = this.state.users;
      return users.map(function (userItem, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: index,
          className: "remotecare-admin-panel-user-element",
          "data-user-id": userItem.id,
          "data-user-index": index,
          "data-user-invitationid": userItem.invitationId,
          "data-person-id": userItem.personId
        }, /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[0]
        }, /*#__PURE__*/React.createElement("span", null, userItem.firstName)), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[1]
        }, /*#__PURE__*/React.createElement("span", null, userItem.lastName)), _this8.settings.UseDataLocation ? /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[2]
        }, /*#__PURE__*/React.createElement("span", null, userItem.countryName)) : null, /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[3] : _this8.state.tableColumnTitles[2]
        }, /*#__PURE__*/React.createElement("span", null, userItem.email)), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[4] : _this8.state.tableColumnTitles[3],
          "data-user-status": userItem.status
        }, /*#__PURE__*/React.createElement("span", {
          className: setUserStatusIcon(userItem.status)
        }), /*#__PURE__*/React.createElement("span", {
          className: setUserStatusClassName(userItem.status)
        }, _this8.setUserStatusLabel(userItem.status))), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[5] : _this8.state.tableColumnTitles[4],
          style: cellActionsStyles
        }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-edit",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: !setUserStatusBtn(userItem.status)
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.EditUser, "  "), /*#__PURE__*/React.createElement("span", {
          className: "icon-edit"
        }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-invitation",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: setUserStatusBtn(userItem.status)
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.SendInvite, " "), /*#__PURE__*/React.createElement("span", {
          className: "icon-send-invite"
        }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-remove",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: userItem.isAdmin
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.RemoveUser, " "), /*#__PURE__*/React.createElement("span", {
          className: "icon-remove"
        }))))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        users = _this$state.users,
        loading = _this$state.loading,
        loadMore = _this$state.loadMore,
        loadOnSearch = _this$state.loadOnSearch;
      return /*#__PURE__*/React.createElement(Fragment, null, !loadMore ?
      // first load or after search
      users.length > 0 ?
      // Display loader on search || user list
      loadOnSearch ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, /*#__PURE__*/React.createElement(Loader, null))) : this.RendererUsers() :
      /*#__PURE__*/
      // Display loader || message not found
      React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, loading ? /*#__PURE__*/React.createElement(Loader, null) : showMsg(this.msg.notFound))) : [
      // Display user list and loader when try load more
      this.RendererUsers(), loading && /*#__PURE__*/React.createElement("tr", {
        key: users.length + 1
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, /*#__PURE__*/React.createElement(Loader, null)))]);
    }
  }]);
}(React.Component);
export default UsersList;